export class EnvironmentService {
    public webCoreServicio = '';
    public webCorePuerto = '';
    public downloadApiService = '';
    public signaturApiService = '';
    public enableDebug = true;
    public useApiSignature = true;
    public signNetApi = '';
    constructor() {
    }
  
  }
  